<template>
  <v-menu bottom offset-y left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon small v-bind="attrs" v-on="on" class="ml-2">
        <v-icon>mdi-settings-helper</v-icon>
      </v-btn>
    </template>

    <v-card max-width="300" tile>
      <v-list dense>
        <v-list-item-group @change="(value) => $emit('export', value)">
          <v-list-item v-for="(item, index) in menuOptions" :key="index">
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon small v-text="item.icon"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "WidgetSettingsMenu",

  props: {
    menuOptions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
